<template>
  <div v-if="order" class="forms-elements">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />

    <Widget v-if="order">
      <OrderForm :order="order" @update:order="orderLocalUpdate" @save="handleSave" />

      <b-row>
        <b-col lg="12" md="12" sm="12">
          <ButtonBar
            :showDeleteButton="buttons.showDeleteButton"
            :model="order"
            modelEditRoute="OrderEditPage"
            modelListRoute="OrdersPage"
            modelRouteParamName="orderNumber"
            :updateCallback="updateOrder"
            :createCallback="createOrder"
            :deleteCallback="deleteOrder"
            :fetchPaginatedCallback="fetchOrdersPaginated"
          />
        </b-col>
      </b-row>
    </Widget>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import Breadcrumbs from '@/components/Breadcrumbs';
import { mapGetters, mapActions } from 'vuex';
import ButtonBar from '@/components/ButtonBar.vue';
import OrderForm from '@/components/Orders/OrderForm.vue';

export default {
  name: 'OrderEditPage',
  components: {
    Widget,
    Breadcrumbs,
    ButtonBar,
    OrderForm,
  },
  props: {
    orderNumber: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      number: null,
    };
  },
  computed: {
    ...mapGetters(['getOrderByNumber']),
    buttons() {
      return {
        showDeleteButton: this.order && this.order.number !== '_new' ? true : false,
      };
    },
    order() {
      return this.getOrderByNumber(this.number);
    },
    breadcrumbs() {
      return [
        { name: 'Home', route: { name: 'home' } },
        { name: this.$t('orders'), route: { name: 'OrdersPage' } },
        { name: this.order.number !== '_new' ? this.$t('edit') : this.$t('new') },
      ];
    },
  },
  methods: {
    ...mapActions([
      'fetchOrdersPaginated',
      'fetchOrderByNumber',
      'updateOrder',
      'createOrder',
      'deleteOrder',
      'initOrder',
      'orderLocalUpdate',
    ]),

    async handleSave(order) {
      if (order.number === '_new') {
        await this.createOrder(order);
      } else {
        await this.updateOrder(order);
      }
    },
  },
  async mounted() {
    console.log('OrderEdit:mounted', this.orderNumber);
    if (!this.order && this.orderNumber) {
      this.number = this.orderNumber;
      await this.fetchOrderByNumber(this.number);
    } else {
      this.initOrder();
      this.number = '_new';
    }
  },
  watch: {
    order(newValue, oldValue) {
      console.log('OrderEdit:order changed', newValue);
    },
  },
};
</script>

<style scoped lang="scss">
.p-calendar {
  width: 100%;
}
</style>
